import {
  Icon,
  utils as designUtils
} from '@febos-io/design';

import ModalDialog from './ModalDialog';
import { useModalContext } from '../providers';
import useTranslation from '../hooks/useTranslation';

export function ModalApiError() {
  const { modalPayload } = useModalContext();
  const {
    message,
    trackingId,
    errors = [],
    code
  } = modalPayload;
  const { t } = useTranslation();
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    designUtils.success(t('Copied to clipboard'));
  };
  return (
    <ModalDialog
      useBackdropClose
      useCloseModal
      title={t('Ups! Something is wrong...')}
      className="modal-dialog-centered"
    >
      <div className="modal-body">
        <div className="container">
          <div className="row">
            <div className="col-10">
              <h5 className="text-primary">
                <Icon icon="circle-exclamation" className="me-1" />
                {message}
              </h5>
            </div>
            <div className="col-2">
              <span className="badge rounded-pill bg-primary">
                {t('Cod')}
                :
                {` ${code}`}
              </span>
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-12">
              <ul className="list-group list-group-flush">
                {errors.map((error, index) => (
                  <li
                    key={`${error}-${index}`}
                    className="list-group-item py-0 d-flex justify-content-between align-items-center"
                  >
                    {t(error)}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="row mt-1">
            <div
              tabIndex={0}
              role="button"
              onKeyDown={() => copyToClipboard(trackingId)}
              onClick={() => copyToClipboard(trackingId)}
              className="col-12 d-flex justify-content-start align-items-center fs-6"
            >
              <Icon icon="copy" className="me-1" />
              <div>
                <strong>
                  <small className="text-muted">{trackingId}</small>
                  <br />
                  <small className="text-muted">{t('Click to copy automatically')}</small>
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalDialog>
  );
}

export default ModalApiError;
